import { createStore } from 'vuex'
import dealer from './dealer'
import attribute from './attribute'

const state = () => ({
  initialized: false,
  detailListingBase: window.app.dealersearch_list.detail_listing_base,
  mandant: window.app.dealersearch_list.client,
  errors: [],
  location: '',
  latitude: '',
  longitude: '',
  country: ''
})

const getters = {}

const mutations = {
  setInitialized (state, payload) {
    state.initialized = payload
  },
  setErrors (state, payload) {
    state.errors.push(payload)
  },
  setLocation (state, payload) {
    state.location = payload
  },
  setLatitude (state, payload) {
    state.latitude = payload
  },
  setLongitude (state, payload) {
    state.longitude = payload
  },
  setCountry (state, payload) {
    state.country = payload
  }
}

const actions = {
  init ({ state, dispatch, commit }) {
    if (state.country) {
      Promise.all([
        dispatch('attribute/get'),
        dispatch('dealer/get')
      ]).then(() => {
        commit('setInitialized', true)
      })
    } else {
      Promise.all([
        dispatch('attribute/get'),
        dispatch('dealer/get')
      ]).then(() => {
        commit('setInitialized', true)
      })
    }
  },
  updateLocation ({ commit }, payload) {
    commit('setLocation', payload.location)
    commit('setLatitude', payload.latitude)
    commit('setLongitude', payload.longitude)
    commit('setCountry', payload.country)
  },
  filter ({ commit, dispatch }) {
    commit('dealer/resetCurrentPage')
    dispatch('pushState')
    Promise.all([
      dispatch('dealer/get')
    ])
  },
  pushState ({ state }) {
    const url = new URL(window.location.href)
    url.searchParams.delete('location-name')
    url.searchParams.delete('country')
    url.searchParams.delete('lat')
    url.searchParams.delete('lng')
    url.searchParams.delete('categories')
    if (state.location) {
      url.searchParams.set('location-name', state.location)
    }
    if (state.location) {
      url.searchParams.set('country', state.country)
    }
    if (state.latitude && state.longitude) {
      url.searchParams.set('lat', state.latitude)
      url.searchParams.set('lng', state.longitude)
    }
    if (state.attribute.filterCategories.length > 0) {
      url.searchParams.set('categories', state.attribute.filterCategories.toString())
    }
    window.history.pushState({}, '', url)
  },
  loadMore ({ commit, dispatch }) {
    commit('dealer/increaseCurrentPage')
    Promise.all([
      dispatch('dealer/get')
    ])
  }
}

const modules = {
  dealer: dealer,
  attribute: attribute
}

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules
})
